import { differenceInDays } from "date-fns";
export const contractFulfillmentErrors = ({ contract, terms, numOrders, endingInvoice, }) => {
    const unfulfilledTerms = [];
    /**
     * `createdAt` represents the original creation date of the subscription
     * exposed by getSubscriptionContractDetails.
     *
     * If `previousContractCreatedAt` exists, it explicitly represents the date
     * from which the current contract's binding period should be calculated.
     *
     * This is especially important for migrated SALTO contracts where
     * previousContractCreatedAt may be newer than saltoCreatedAt.
     */
    const bindingPeriodStartedAt = contract.previousContractCreatedAt
        ? new Date(contract.previousContractCreatedAt)
        : new Date(contract.createdAt);
    const daysSinceBindingPeriodStarted = differenceInDays(new Date(), bindingPeriodStartedAt);
    if (terms.binding_period_days > daysSinceBindingPeriodStarted) {
        unfulfilledTerms.push({
            terms,
            termsMet: {
                binding_period_days: daysSinceBindingPeriodStarted,
                minimum_orders: numOrders,
            },
            type: "binding_period",
            cancellable: false,
            message: `Contract ${contract.id} is not cancellable, binding period not met. Binding period: ${terms.binding_period_days} days. Days since binding period started: ${daysSinceBindingPeriodStarted}`,
            displayMessage: `Bindingstid på ${terms.binding_period_days - daysSinceBindingPeriodStarted} dager gjenstår`,
            endingInvoice: endingInvoice
                ? {
                    sku: endingInvoice.sku,
                    name: endingInvoice.name,
                    image: endingInvoice.image,
                    price: endingInvoice.price,
                    alternativePrice: endingInvoice.alternativePrice,
                }
                : undefined,
        });
    }
    if (terms.minimum_orders > numOrders) {
        unfulfilledTerms.push({
            terms,
            termsMet: {
                binding_period_days: daysSinceBindingPeriodStarted,
                minimum_orders: numOrders,
            },
            type: "minimum_orders",
            cancellable: false,
            message: `Contract ${contract.id} is not cancellable, minimum orders not met.`,
            displayMessage: `Krav om minstekjøp ikke oppnådd.`,
        });
    }
    return unfulfilledTerms;
};
